import React, {useCallback, useMemo} from "react";
import {DataTable, DataTableColumnProps, DataTableUrl} from "peggirkit";
import {RestaurantSyncLog} from "@/data/entities/sync";
import {useIntl} from "react-intl";
import {getSynchronizationLogsDataTableColumns} from "@widgets/synchronization/overview/dataTable/columns/Columns";
import {globalDataTableProps} from "@/utils/DataTableUtils";
import {eatalianoAxios} from "@/data/api/http/axios";

const itemsPerPage = 15;

type Props = {
    logsLastUpdated: Date,
};

const SynchronizationLogsDataTable = ({logsLastUpdated}: Props) => {
    const intl = useIntl();
    const dataUrl: DataTableUrl = useCallback(
        () => new URL(`${process.env.BACKEND_API_BASE_URL}/admin/sitedish/sync/logs`).toString(),
        []);
    const columns: DataTableColumnProps<RestaurantSyncLog>[] = useMemo(
        () => getSynchronizationLogsDataTableColumns(intl),
        [intl]);

    return (
        <DataTable<RestaurantSyncLog>
            {...globalDataTableProps<RestaurantSyncLog>(intl)}
            key={logsLastUpdated.toISOString()}
            label={intl.formatMessage({id: "synchronizationLogs"})}
            axios={eatalianoAxios}
            url={dataUrl}
            columns={columns}
            columnSortingOptions={{
                sortParameterName: "sort",
            }}
            paginationOptions={{
                pageSize: itemsPerPage,
                pageNumber: 0,
                scrollToTopOnPageChange: true,
                currentPageParameter: "page",
            }}
            loadingConfig={{
                skeletonRepeat: itemsPerPage,
            }}
            rowConfig={{
                hoverEffect: true,
            }}
        />
    );
};

export default SynchronizationLogsDataTable;